import React, { useState, useEffect } from "react";
import LZString from "lz-string";
import Stats4 from "./stats4";
import Stats4x1 from "./stats4x1";
import AdvStats1 from './adv/advstats1';
import InflMain from './infl/inflmain';
import InflPrograms from "./infl/inflprograms";
import './stats.css';

const CodesPerf = () => {
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [activeView, setActiveView] = useState('main');
    const [influencerView, setInfluencerView] = useState('main'); // 'main' or 'programs'

    useEffect(() => {
        const compressedData = sessionStorage.getItem("rawOrdersData");
        if (compressedData) {
            const decompressedData = JSON.parse(LZString.decompress(compressedData));
            console.log("Decompressed Orders Data:", decompressedData);
            setFilteredOrders(decompressedData || []);
        } else {
            console.warn("No compressed data found in sessionStorage.");
        }
    }, []);

    return (
        <div className="stats-container">
            <div className="stats-nav">
                <button 
                    className={`nav-button ${activeView === 'main' ? 'active' : ''}`}
                    onClick={() => setActiveView('main')}
                >
                    Main
                </button>
                <button 
                    className={`nav-button ${activeView === 'advanced' ? 'active' : ''}`}
                    onClick={() => setActiveView('advanced')}
                >
                    Advanced
                </button>
                <button 
                    className={`nav-button ${activeView === 'influencers' && influencerView === 'main' ? 'active' : ''}`}
                    onClick={() => {
                        setActiveView('influencers');
                        setInfluencerView('main');
                    }}
                >
                    Influencers
                </button>
                <button 
                    className={`nav-button ${activeView === 'influencers' && influencerView === 'programs' ? 'active' : ''}`}
                    onClick={() => {
                        setActiveView('influencers');
                        setInfluencerView('programs');
                    }}
                >
                    Programs
                </button>

            </div>

            {activeView === 'main' ? (
                <>
                    <Stats4x1 />
                    
                    <Stats4 />
                    
                </>
            ) : activeView === 'advanced' ? (
                <AdvStats1 orders={filteredOrders} />
            ) : (
                // Influencers view - now handling both main and programs views
                influencerView === 'main' ? (
                    <InflMain orders={filteredOrders} />
                ) : (
                    <InflPrograms orders={filteredOrders} />
                )
            )}
        </div>
    );
};

export default CodesPerf;
